import $ from "cash-dom";
import algoliasearch from "algoliasearch";
import autocomplete from "autocomplete.js";
var dev = process.env.NODE_ENV === "development"; // https://github.com/algolia/algoliasearch-client-javascript

var applicationId = "2HYPB2F2D4";
var apiKey = "288ffc465a8c1195c30b8c2606dbce4a";
var client = algoliasearch(applicationId, apiKey);
var prefix = document.querySelector('meta[name="algolia-prefix"]').content;
var cmsIndex = client.initIndex("".concat(prefix, "_cms"));
var mainIndex = client.initIndex("".concat(prefix, "_main"));

function suggestionTemplate(suggestion) {
  // for the categories in here we use isNaN to only display
  // tags that cannot be cast into integers
  return "\n    <a class=\"aa-suggestion-link uk-link-reset\" :to=\"'".concat(suggestion.url, "'\">\n      <span class=\"aa-suggestion-title\">").concat(suggestion._highlightResult.title.value, "</span>\n        ").concat(suggestion.search_category ? "\n        <span class=\"aa-suggestion-categories\">\n          <span>".concat(suggestion.search_category, "</span>\n        </span>\n      ") : "", "\n    </a>\n  ");
}

function updateLocation(dataset, suggestion) {
  // Follow link to page when user hits enter key while item is selected
  location.href = suggestion.url;
}

export default function Search() {
  var autocompleteDivs = document.querySelectorAll(".js-search").length;

  if (autocompleteDivs === 0) {
    return;
  }

  document.getElementById("search-field").onkeyup = function (e) {
    document.querySelector(".see-all-link").setAttribute("href", "//".concat(window.location.host, "/search/?query=").concat(this.value));
  };

  var globalAutocompleteOptions = {
    // autoWidth: false,
    autoselect: true,
    openOnFocus: true,
    debug: dev,
    cssClasses: {
      root: "algolia-autocomplete algolia-autocomplete--global"
    },
    templates: {
      footer: "<div class=\"aa-search-footer flex justify-end my-3\"><a class=\"see-all-link ml-auto linked\" href=\"/search/?query=".concat(document.getElementById("search-field").value, "\">See All Results</a></div>"),
      empty: '<div class="my-5"><h4 class="font-bold text-lg text-gray-900 my-3">Sorry, we did not find any matching results.</h4><p class="my-3 ts-p text-base text-gray-700">We frequently add data and we\'re interested in what would be useful to people. If you have a specific recommendation, you can reach us at info@usafacts.org.</p><p class="my-3 ts-p text-base text-gray-700">We are in the process of adding data at the state and local level. Sign up on our mailing list here to be the first to know when it is available.</p><h5 class="mt-5 mb-1 text-xs uppercase text-gray-900 font-bold tracking-widest">Search tips:</h5><p class="text-base my-2 text-gray-700">&#8226; Check your spelling</p><p class="text-base my-2 text-gray-700">&#8226; Try other search terms</p><p class="text-base my-2 text-gray-700">&#8226; Use fewer words</p></div>'
    }
  };
  var search = autocomplete("#search-field", globalAutocompleteOptions, [{
    source: function source(query, callback) {
      cmsIndex.search(query, {
        hitsPerPage: 10
      }).then(function (answer) {
        callback(answer.hits);
      }, function () {
        callback([]);
      });
    },
    displayKey: "title",
    templates: {
      // header: '<div class="aa-suggestions-category">Results</div>',
      suggestion: function suggestion(_suggestion) {
        return suggestionTemplate(_suggestion);
      }
    }
  }, {
    source: function source(query, callback) {
      mainIndex.search(query, {
        hitsPerPage: 10
      }).then(function (answer) {
        callback(answer.hits);
      }, function () {
        callback([]);
      });
    },
    displayKey: "title",
    templates: {
      // header: '<div class="aa-suggestions-category">Results</div>',
      suggestion: function suggestion(_suggestion2) {
        return suggestionTemplate(_suggestion2);
      }
    }
  }]);
  search.on("autocomplete:selected", updateLocation);
  search.on("autocomplete:selected", function () {
    search.autocomplete.setVal("");
  });

  function popKeyboard(input) {
    input.focus();
    input.setSelectionRange(0, 0);
  }

  $(".search__toggle").on("click touchend", function (e) {
    if ($(".search__form").hasClass("is-open")) {// $('.search__form').removeClass('is-open');
      // $('.search__form').removeClass('is-open');
      // $('body').removeClass('is-menuopen');
      // document.getElementById('search-field').blur();
    } else {
      // $('.search__form').addClass('is-open');
      // document.getElementById('search-field').focus();
      popKeyboard(document.getElementById("search-field"));
      $(".search__form").addClass("is-open");
      $("body").addClass("is-menuopen");
    }

    e.preventDefault();
  });
  $(".search__field").on("keyup", function (e) {
    if (document.getElementById("search-field").value) {
      $(".search__form").addClass("is-open");
      $("body").addClass("is-menuopen");
    } else {
      $(".search__form").removeClass("is-open");
      $("body").removeClass("is-menuopen");
    }
  });
  $(".search__field").on("blur", function () {// $('.search__form').removeClass('is-open');blur
  });
  $(".search__close").on("click touchend", function (e) {
    $(".search__form").removeClass("is-open");
    $("body").removeClass("is-menuopen");
    e.preventDefault();
  });
}